module.exports = __webpack_public_path__ + "static/img/loading.c71e7c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/public/3d/res/imgs/joystick/loading.png
// module id = ZKl9
// module chunks = 1